import {FC, useState, useEffect, useRef} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import Select from 'react-select'

import './style.css'

import UploadFotoProfile from './UploadFotoProfile'
import {scrollToElement} from 'thesis-and-dissertations/helpers/helper'

const api = new Api()

type Props = {
  showFormModal: boolean
  id: any
  handleCloseFormModal: any
  handleReload: any
}
const FormAddContent: FC<Props> = ({showFormModal, id, handleCloseFormModal, handleReload}) => {
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const [formValue, setFormValue] = useState<any>({})
  const [bidangSektor, setBidangSektor] = useState<any>([])

  const [fieldRefs, setFieldRefs] = useState<any>({
    nib_nik: useRef(null),
    priority: useRef(null),
    nama_lengkap: useRef(null),
    gelar_akademik_depan: useRef(null),
    foto_profil: useRef(null),
    linkedin_profile: useRef(null),
    program_beasiswa: useRef(null),
    jenjang_studi: useRef(null),
    universitas: useRef(null),
    negara: useRef(null),
    tahun_lulus: useRef(null),
    bidang_studi: useRef(null),
    pekerjaan_saat_ini: useRef(null),
    perusahaan_instansi: useRef(null),
    bidang_sektor: useRef(null),
    deskripsi_singkat_pekerjaan: useRef(null),
    biography: useRef(null),
    prestasi_utama: useRef(null),
    kontribusi_masyarakat: useRef(null),
    kutipan_inspiratif: useRef(null),
    pesan_untuk_calon_awardee: useRef(null),
    kenangan_paling_berkesan_studi: useRef(null),
  })

  useEffect(() => {
    getBidangSektor()
  }, [])

  useEffect(() => {
    if (!errors) {
      return
    }

    scrollToElement(errors, fieldRefs)
  }, [errors])

  useEffect(() => {
    setShowModal(showFormModal)

    if (id) {
      getProfileById(id)
    }
  }, [showFormModal])

  const toggle = () => {
    setShowModal(!showModal)
    handleCloseFormModal()

    setErrors({})
    setFormValue({})
  }

  const handleInput = (name: string, e: any) => {
    setFormValue({...formValue, [name]: e.target.value})
    setErrors({})
  }

  const getProfileById = (id: any) => {
    setIsLoading(true)
    api
      .getDetailProfile(id)
      .then((response: any) => {
        setIsLoading(false)
        const {data} = response.data

        formValue['nib_nik'] = data?.no_induk_beasiswa ?? data?.nik
        formValue['bidang_sektors'] = bidangSektor?.map((item: any) => {
          if (item?.value != data?.bidang_sektor) {
            return
          }

          return item
        })
        data['foto_profil'] = ''
        data['is_setuju'] = ''
        setFormValue({...formValue, ...data})
        toast.success(data?.meta?.message ?? data?.message)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error ?? data?.meta?.message)
        toast.error(data?.meta?.message)
      })
  }

  const getBidangSektor = () => {
    setIsLoading(true)
    api
      .getBidangSektor()
      .then((response: any) => {
        setIsLoading(false)
        const {data} = response.data
        setBidangSektor(data.items)
      })
      .catch((error: any) => {
        setIsLoading(false)
      })
  }

  const onSubmit = () => {
    setIsLoading(true)

    let apiAction
    if (id) {
      apiAction = api.editProfile(id, formValue)
    } else {
      apiAction = api.saveProfile(formValue)
    }

    apiAction
      .then((response: any) => {
        setIsLoading(false)
        const {data} = response
        toast.success(data?.meta?.message ?? data?.message)
        toggle()
        handleReload(true)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error ?? data?.meta?.message)
        toast.error(data?.meta?.message)
      })
  }

  const getAlumniByNib = (nib: string) => {
    setIsLoading(true)
    api
      .getAlumniByNib({nib_nik: nib})
      .then((response: any) => {
        setIsLoading(false)
        const {data} = response.data
        setFormValue({...formValue, ...data})
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        toast.error(data?.meta?.message)
      })
  }

  const handleSelectFile = (file: any) => {
    if (!file) {
      return
    }

    setFormValue({...formValue, ...{foto_profil: file}})
  }

  return (
    <Modal show={showModal} onHide={toggle} size='xl' centered>
      <Modal.Body>
        <div className='d-flex justify-content-between'>
          <div>
            <h6 className='mb-2 h6-title'>Tambah Profil Alumni Manual</h6>
            <p className='mb-4'>
              Lengkapi informasi berikut untuk menampilkan perjalanan, prestasi, dan kontribusi Anda
              di halaman Featured Alumni LPDP.
            </p>
          </div>

          <div className='d-flex justify-content-end' onClick={toggle} style={{cursor: 'pointer'}}>
            <span className='fa fa-close' />
          </div>
        </div>

        <Form>
          <Row>
            {/* Informasi Pribadi */}
            <Col md={6}>
              <div className='mb-4 border p-8 rounded'>
                <h6 className='mb-4 h6-text'>Informasi Pribadi</h6>

                <Form.Group className={'mb-4'}>
                  <Form.Label>
                    No Induk Beasiswa/NIK/Kode Reg <i className='text-danger'>*</i>
                  </Form.Label>

                  <div style={{position: 'relative', width: '100%'}}>
                    <input
                      ref={fieldRefs.nib_nik}
                      type='text'
                      className={`${
                        errors?.nib_nik ? 'border-danger form-control pe-5' : 'form-control pe-5'
                      }`}
                      placeholder='Masukan No Induk Beasiswa/NIK/Kode Reg'
                      value={formValue?.nib_nik}
                      onChange={(e) => {
                        handleInput('nib_nik', e)
                      }}
                      onKeyDown={(e) => {
                        if (e.key != 'Enter') {
                          return
                        }

                        getAlumniByNib(formValue?.nib_nik)
                      }}
                    />

                    <button
                      type='button'
                      onClick={() => getAlumniByNib(formValue?.nib_nik)}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#F95E2F',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '6px 14px',
                        fontWeight: 'bold',
                      }}
                    >
                      Enter
                    </button>
                  </div>

                  <p style={{color: '#667085', fontSize: '12px'}} className='mt-2 text-muted'>
                    Tekan <span className='fw-bold'>Enter</span> setelah mengisi data untuk
                    melanjutkan.
                  </p>

                  {errors?.nib_nik ? <p className='text-danger mt-1'>{errors?.nib_nik}</p> : null}
                </Form.Group>

                {/* <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Priority (angka 1-6) <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.priority}
                    type='number'
                    placeholder='Masukan Priority'
                    className={`${errors?.priority ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('priority', e)}
                    value={formValue?.priority}
                  />

                  {errors?.priority ? <p className='text-danger mt-1'>{errors?.priority}</p> : null}
                </Form.Group> */}

                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Nama Lengkap <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.nama_lengkap}
                    type='text'
                    placeholder='Masukan Nama Lengkap'
                    className={`${errors?.nama_lengkap ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('nama_lengkap', e)}
                    value={formValue?.nama_lengkap}
                    disabled={true}
                  />

                  {errors?.nama_lengkap ? (
                    <p className='text-danger mt-1'>{errors?.nama_lengkap}</p>
                  ) : null}
                </Form.Group>

                <div className='row mb-3'>
                  <div className='col-md-6'>
                    <Form.Group className='mb-3'>
                      <p className='mb-1'>Gelar Akademik Depan</p>
                      <Form.Control
                        ref={fieldRefs.gelar_akademik_depan}
                        type='text'
                        placeholder='Prof., Dr.'
                        className={`${errors?.gelar_akademik_depan ? 'border-danger' : ''}`}
                        onChange={(e) => handleInput('gelar_akademik_depan', e)}
                        value={formValue?.gelar_akademik_depan}
                      />

                      {errors?.gelar_akademik_depan ? (
                        <p className='text-danger mt-1'>{errors?.gelar_akademik_depan}</p>
                      ) : null}
                    </Form.Group>
                  </div>
                  <div className='col-md-6'>
                    <Form.Group className='mb-3'>
                      <p className='mb-1'>
                        Gelar Akademik Belakang <i className='text-danger'>*</i>
                      </p>
                      <Form.Control
                        ref={fieldRefs.gelar_akademik_belakang}
                        type='text'
                        placeholder='S.Kom., M.Sc., Ph.D.'
                        className={`${errors?.gelar_akademik_belakang ? 'border-danger' : ''}`}
                        onChange={(e) => handleInput('gelar_akademik_belakang', e)}
                        value={formValue?.gelar_akademik_belakang}
                      />

                      {errors?.gelar_akademik_belakang ? (
                        <p className='text-danger mt-1'>{errors?.gelar_akademik_belakang}</p>
                      ) : null}
                    </Form.Group>
                  </div>
                </div>

                <div className='mb-8' ref={fieldRefs.foto_profil}>
                  <UploadFotoProfile handleSelectFile={handleSelectFile} />

                  {errors?.foto_profil ? (
                    <p className='text-danger mt-1'>{errors?.foto_profil}</p>
                  ) : null}
                </div>

                <Form.Group>
                  <p className='mb-1'>
                    Tautan Profil LinkedIn <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.linkedin_profile}
                    type='url'
                    placeholder='Contoh: https://linkedin.com/in/username'
                    className={`${errors?.linkedin_profile ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('linkedin_profile', e)}
                    value={formValue?.linkedin_profile}
                  />

                  {errors?.linkedin_profile ? (
                    <p className='text-danger mt-1'>{errors?.linkedin_profile}</p>
                  ) : null}
                </Form.Group>
              </div>
            </Col>

            {/* Informasi Akademik */}
            <Col md={6}>
              <div className='mb-4 border p-8 rounded'>
                <h6 className='mb-4 h6-text'>Informasi Akademik</h6>

                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Program Beasiswa <i className='text-danger'>*</i>
                  </p>

                  <Form.Control
                    ref={fieldRefs.program_beasiswa}
                    type='text'
                    placeholder='Contoh: Harvard University'
                    className={`${errors?.program_beasiswa ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('program_beasiswa', e)}
                    value={formValue?.program_beasiswa}
                    disabled={true}
                  />

                  {errors?.program_beasiswa ? (
                    <p className='text-danger mt-1'>{errors?.program_beasiswa}</p>
                  ) : null}
                </Form.Group>

                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Jenjang <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.jenjang_studi}
                    type='text'
                    placeholder='Masukan Jenjang Studi'
                    className={`${errors?.jenjang_studi ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('jenjang_studi', e)}
                    value={formValue?.jenjang_studi}
                    disabled={true}
                  />

                  {errors?.program_beasiswa ? (
                    <p className='text-danger mt-1'>{errors?.jenjang_studi}</p>
                  ) : null}
                </Form.Group>

                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Universitas <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.universitas}
                    type='text'
                    placeholder='Contoh: Harvard University'
                    className={`${errors?.universitas ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('universitas', e)}
                    value={formValue?.universitas}
                    disabled={true}
                  />

                  {errors?.program_beasiswa ? (
                    <p className='text-danger mt-1'>{errors?.universitas}</p>
                  ) : null}
                </Form.Group>
                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Negara <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.negara}
                    type='text'
                    placeholder='Contoh: Inggris'
                    className={`${errors?.negara ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('negara', e)}
                    value={formValue?.negara}
                    disabled={true}
                  />

                  {errors?.negara ? <p className='text-danger mt-1'>{errors?.negara}</p> : null}
                </Form.Group>
                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Tahun Lulus <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.tahun_lulus}
                    type='number'
                    placeholder='Masukan tahun kelulusan'
                    className={`${errors?.tahun_lulus ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('tahun_lulus', e)}
                    value={formValue?.tahun_lulus}
                    disabled={true}
                  />

                  {errors?.tahun_lulus ? (
                    <p className='text-danger mt-1'>{errors?.tahun_lulus}</p>
                  ) : null}
                </Form.Group>
                <Form.Group className='mb-3' style={{paddingBottom: '170px'}}>
                  <p className='mb-1'>
                    Bidang Studi <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.bidang_studi}
                    type='text'
                    placeholder='Contoh: Public Policy'
                    className={`${errors?.bidang_studi ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('bidang_studi', e)}
                    value={formValue?.bidang_studi}
                    disabled={true}
                  />

                  {errors?.bidang_studi ? (
                    <p className='text-danger mt-1'>{errors?.bidang_studi}</p>
                  ) : null}
                </Form.Group>
              </div>
            </Col>
          </Row>

          {/* Informasi Profesional */}
          <h6 className='mt-8 mb-2 h6-title'>Informasi Profesional</h6>
          <p className='mb-4'>Juga ditampilkan di profil publik</p>
          <div className='border p-8 rounded'>
            <h6 className='mb-4 h6-text'>Informasi Profesional</h6>
            <div className='row'>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Pekerjaan Saat Ini <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.pekerjaan_saat_ini}
                    type='text'
                    placeholder='Contoh: Analis Kebijakan Madya'
                    className={`${errors?.pekerjaan_saat_ini ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('pekerjaan_saat_ini', e)}
                    value={formValue?.pekerjaan_saat_ini}
                  />

                  {errors?.pekerjaan_saat_ini ? (
                    <p className='text-danger mt-1'>{errors?.pekerjaan_saat_ini}</p>
                  ) : null}
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <p className='mb-1'>
                    Perusahaan/Instansi <i className='text-danger'>*</i>
                  </p>
                  <Form.Control
                    ref={fieldRefs.perusahaan_instansi}
                    type='text'
                    placeholder='Contoh: Kementrian Keuangan RI'
                    className={`${errors?.perusahaan_instansi ? 'border-danger' : ''}`}
                    onChange={(e) => handleInput('perusahaan_instansi', e)}
                    value={formValue?.perusahaan_instansi}
                  />

                  {errors?.perusahaan_instansi ? (
                    <p className='text-danger mt-1'>{errors?.perusahaan_instansi}</p>
                  ) : null}
                </Form.Group>
              </div>
            </div>
            <Form.Group className='mb-3'>
              <p className='mb-1'>
                Bidang/Sektor <i className='text-danger'>*</i>
              </p>

              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                })}
                className={`mt-2 ${errors?.bidang_sektor ? 'border-danger' : ''}`}
                placeholder='--Pilih Bidang/Sektor--'
                isMulti={false}
                options={bidangSektor}
                value={formValue?.bidang_sektors}
                getOptionLabel={(opt: any) => opt?.label}
                getOptionValue={(opt: any) => opt?.value}
                onChange={(selected) => {
                  setFormValue({
                    ...formValue,
                    bidang_sektors: selected,
                    bidang_sektor: selected.value,
                  })
                }}
                isLoading={false}
              />

              {errors?.bidang_sektor ? (
                <p className='text-danger mt-1'>{errors?.bidang_sektor}</p>
              ) : null}
            </Form.Group>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Deskripsi Singkat Pekerjaan (2–3 kalimat)</p>
              <Form.Control
                ref={fieldRefs.deskripsi_singkat_pekerjaan}
                as='textarea'
                rows={2}
                placeholder='Ringkas peran utama dan dampak. Contoh: “Merancang dan mengevaluasi kebijakan fiskal untuk mendukung transisi energi terbarukan di Indonesia; berkolaborasi dengan lembaga internasional.'
                className={`${errors?.deskripsi_singkat_pekerjaan ? 'border-danger' : ''}`}
                onChange={(e) => handleInput('deskripsi_singkat_pekerjaan', e)}
                value={formValue?.deskripsi_singkat_pekerjaan}
              />
              <p className='text-muted'>Maks 300 karakter. Fokus pada dampak.</p>

              {errors?.deskripsi_singkat_pekerjaan ? (
                <p className='text-danger mt-1'>{errors?.deskripsi_singkat_pekerjaan}</p>
              ) : null}
            </Form.Group>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Biografi Singkat</p>
              <Form.Control
                ref={fieldRefs.biography}
                as='textarea'
                rows={2}
                placeholder='Ceritakan perjalanan singkat sejak lulus hingga posisi saat ini (1–2 paragraf).'
                className={`${errors?.biography ? 'border-danger' : ''}`}
                onChange={(e) => handleInput('biography', e)}
                value={formValue?.biography}
              />
              <p className='text-muted'>Maks 1.000 karakter.</p>

              {errors?.biography ? <p className='text-danger mt-1'>{errors?.biography}</p> : null}
            </Form.Group>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Prestasi Utama (opsional)</p>
              <Form.Control
                ref={fieldRefs.prestasi_utama}
                as='textarea'
                rows={2}
                placeholder='Sebutkan 1–3 prestasi paling membanggakan. Contoh: “TOP 45 Inovasi Pelayanan Publik 2024.'
                className={`${errors?.prestasi_utama ? 'border-danger' : ''}`}
                onChange={(e) => handleInput('prestasi_utama', e)}
                value={formValue?.prestasi_utama}
              />
              <p className='text-muted'>Gunakan titik koma untuk memisahkan.</p>

              {errors?.prestasi_utama ? (
                <p className='text-danger mt-1'>{errors?.prestasi_utama}</p>
              ) : null}
            </Form.Group>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Kontribusi untuk Masyarakat (opsional)</p>
              <Form.Control
                ref={fieldRefs.kontribusi_masyarakat}
                as='textarea'
                rows={2}
                placeholder='Dampak konkret yang Anda berikan (misal jumlah penerima manfaat, kebijakan yang berubah, publikasi, dsb.)'
                className={`${errors?.kontribusi_masyarakat ? 'border-danger' : ''}`}
                onChange={(e) => handleInput('kontribusi_masyarakat', e)}
                value={formValue?.kontribusi_masyarakat}
              />

              <p className='text-muted'>Maks 700 karakter.</p>
              {errors?.kontribusi_masyarakat ? (
                <p className='text-danger mt-1'>{errors?.kontribusi_masyarakat}</p>
              ) : null}
            </Form.Group>
          </div>

          {/* Konten Flipbook */}
          <h6 className='mt-8 mb-2 h6-title'>Visi, Inspirasi & Personal Touch</h6>
          <p className='mb-4'>Juga ditampilkan di profil publik</p>
          <div className='border p-8 rounded'>
            <h6 className='mb-4 h6-text'>Informasi Profesional</h6>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Kutipan Inspiratif (Quote)</p>
              <Form.Control
                ref={fieldRefs.kutipan_inspiratif}
                as='textarea'
                placeholder='Ilmu itu amal, dan amal itu bukti.'
                rows={2}
                onChange={(e) => handleInput('kutipan_inspiratif', e)}
                value={formValue?.kutipan_inspiratif}
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <p className='mb-1'>Pesan untuk Calon Awardee LPDP (opsional)</p>
              <Form.Control
                ref={fieldRefs.pesan_untuk_calon_awardee}
                as='textarea'
                placeholder='Berikan 1–2 kalimat saran singkat dan membangun.'
                rows={2}
                onChange={(e) => handleInput('pesan_untuk_calon_awardee', e)}
                value={formValue?.pesan_untuk_calon_awardee}
              />
              <p className='text-muted'>
                Berikan 1–2 kalimat saran singkat yang jujur dan membangun.
              </p>
            </Form.Group>

            <Form.Group className='mb-3'>
              <p className='mb-1'>Kenangan Paling Berkesan Selama Studi</p>
              <Form.Control
                ref={fieldRefs.kenangan_paling_berkesan_studi}
                as='textarea'
                placeholder='Berikan 1–2 kalimat saran singkat dan membangun.'
                rows={2}
                onChange={(e) => handleInput('kenangan_paling_berkesan_studi', e)}
                value={formValue?.kenangan_paling_berkesan_studi}
              />
              <p className='text-muted'>
                Cerita singkat tentang tantangan/pertumbuhan personal yang Anda alami.
              </p>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className='btn btn-sm'
          style={{border: '1px solid var(--Primary-L-500, #E4E4E7)'}}
          onClick={toggle}
          disabled={isLoading}
        >
          <i className='fa fa-close'></i> Batal
        </button>

        {formValue?.status != 'Ditolak' && (
          <button className='btn btn-sm btn-primary' disabled={isLoading} onClick={onSubmit}>
            <i className='fa fa-save'></i> {isLoading ? 'Loading...' : 'Simpan Profil Alumni'}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

const FormAdd: FC<Props> = ({showFormModal, id, handleCloseFormModal, handleReload}) => {
  return (
    <FormAddContent
      showFormModal={showFormModal}
      id={id}
      handleCloseFormModal={handleCloseFormModal}
      handleReload={handleReload}
    />
  )
}

export default FormAdd
